module.exports = __webpack_public_path__ + "img/uy.e952b398.svg";